import axios from 'axios'

// 登录
export const formDate = (params) => axios.post(`/prod-api/system/ad`, params)
